import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { MixpanelService } from './core/services/mixpanel.service';
import { AnalyticsService } from './core/services/analytics.service';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { partnerInterceptor } from './core/interceptors/partner.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([partnerInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (mp: MixpanelService) => () => mp.init(),
      deps: [MixpanelService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ga: AnalyticsService) => () => ga.init(),
      deps: [AnalyticsService],
      multi: true,
    },
  ],
};
